import React from "react"
import { connect } from "react-redux"
import { urlFormatter } from "../../../../util"
import { LinkSectionButton } from "../../Section"
import Translation from "../../../../services/translation.service"

import postpaidIcon from "../../../../assets/img/icon/Postpaid.svg"
import prepaidIcon from "../../../../assets/img/icon/Prepaid_Plan.svg"
import lebaraNumbersIcon from "../../../../assets/img/icon/Lebara Number.svg"

const JoinLebara = ({ routes }) => {

    let numberBookingLink = urlFormatter(routes?.['shop-join_lebara-select_number']?.['route']);
    let bringNumber = urlFormatter(routes?.['shop-join_lebara-bring_number']?.['route']);
    let packgeCategoryLink = urlFormatter(routes?.['shop-join_lebara-voice_plans']?.['route']);

    return (
        <li className="nav-list-itm border-bottom desktop-only">
            <div className="nav-list-lnk pointer">{Translation.key("join_lebara_menu_title")}</div>
            <div className="join-lebara-menu">
                <div className="left-nav-section">
                    <div className="left-nav-aligner ">
                        <h3>{Translation.key("start_with_your_plan")}</h3>
                        <div className="first-links-row flex-start">
                          <LinkSectionButton
                            url={packgeCategoryLink}
                            isMainLink={true}
                            text={Translation.key('prepaid')}
                            imgSrc={prepaidIcon}
                            linkParams="prepaid"
                          />
                          <LinkSectionButton
                            url={packgeCategoryLink}
                            isMainLink={true}
                            text={Translation.key('postpaid')}
                            imgSrc={postpaidIcon}
                            linkParams="postpaid"
                          />
                        </div>
                    </div>
                </div>

                <div className="right-nav-section">
                    <div className="right-nav-aligner">
                        <h3>{Translation.key("start_with_your_number")}</h3>
                        <div className="first-links-row flex-start">
                            <LinkSectionButton url={numberBookingLink} isMainLink={true} text={Translation.key("lebara_numbers")} imgSrc={lebaraNumbersIcon} />
                            <LinkSectionButton url={bringNumber} isMainLink={true} text={Translation.key("join_lebara_bring_your_number")} imgSrc={lebaraNumbersIcon} />

                        </div>
                    </div>
                </div>
            </div>

        </li>
    )
}
const mapStateToProps = ({ layout }) => ({
    routes: layout?.routes,
    lang: layout?.iso
})
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(JoinLebara) 
